import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import Slider from "react-slick";
import nextArrow from "../../img/next.png";
import prevArrow from "../../img/prev.png";

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className="absolute w-[40px] h-[100px] z-30 top-[calc(50%-50px)] bottom-0 right-3.5 opacity-30 hover:opacity-100 bg-contain bg-no-repeat p-3 cursor-pointer hover:scale-150 transition duration-250"
            style={{ ...style, display: "block", backgroundImage: `url(${nextArrow})`, backgroundSize: "30px",backgroundPosition: "center" }}
            onClick={onClick}
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className="absolute w-[40px] h-[100px] z-30 top-[calc(50%-50px)] bottom-0 left-3.5 opacity-30 hover:opacity-100 bg-contain bg-no-repeat p-3 cursor-pointer hover:scale-150 transition duration-250"
            style={{ ...style, display: "block", backgroundImage: `url(${prevArrow})`, backgroundSize: "30px",backgroundPosition: "center" }}
            onClick={onClick}
        />
    );
}

function FirstScreenSpeacers({slider_data}) {

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    return (
        slider_data ?
            <div className="sm:px-10 relative" id="spsliders">
                <div className="gallery bg-white pt-10">
                    <div className="slider-container speacersslider">
                        <Slider {...settings}>
                            {
                                slider_data.map((item, value) => (
                                    <>
                                        {item.acf.big_image ?
                                            <div className="relative slick-slide speacer-slide w-full" key={value}>
                                                <div className="relative z-30">
                                                    <img src={item.acf.big_image} alt={item.acf.speacer_name}
                                                         className="bottom-0 left-0 right-0 m-auto z-10 !w-auto h-[100%] max-h-[400px] sm:max-h-[540px] lg:max-h-[580px] 2xl:max-h-[610px]"/>
                                                    <div
                                                        className="bg-white z-20 absolute bottom-0 right-0 p-4 flex w-[100%] m-auto justify-center items-center border-t border-t-1 border-[#f7eae8]">
                                                        <div className="w-[120px] mr-[15px]">
                                                            <img src={item.acf.logo} alt="logo"
                                                                 className="max-h-[50px] mx-auto"/>
                                                        </div>
                                                        <div>
                                                            <h3 className="sm:text-xl">{item.post_title}</h3>
                                                            <p className="max-sm:text-[13px] text-[0.8em] leading-[120%]">{item.acf.position_short ? item.acf.position_short : item.acf.position}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<div*/}
                                                {/*    className="w-full h-full bg-no-repeat absolute left-0 top-1 z-10 opacity-30"*/}
                                                {/*    style={{*/}
                                                {/*        backgroundImage: `url(${item.acf.logo})`,*/}
                                                {/*        backgroundSize: "contain",*/}
                                                {/*        backgroundPosition: "center 80px",*/}
                                                {/*    }}></div>*/}
                                            </div>
                                            : ''}
                                    </>
                                ))
                            }
                        </Slider>
                    </div>
                </div>
            </div>
            : ''
    )
}

export default FirstScreenSpeacers;